/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/forbid-dom-props */
/* eslint-disable max-len */
//
// NB: This Subscribe feature and it's associated Components are for a high
//     volume signup test conducted in a joint partnership with Agent
//     Advice.
//     More details at https://catalyzeai.atlassian.net/wiki/spaces/CC/pages/47513601/Agent+Advice+High+Volume+Signup+Test
//
//
// import { isEmpty, clone, values, sumBy, cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { toast } from 'react-hot-toast';
import { useQueryClient } from 'react-query';
import { useSearchParams } from 'react-router-dom';

import {
    // Button,
    // ButtonVariant,
    PublicLayout,
    Toast,
} from '@catalyze/ui';
import { useCompleteSubscribeMutation } from 'api/subscriptions/completeSubscribe';
import type { IUserProfile } from 'api/types/user';
import { fetchUser } from 'api/users/getUser';
import { LoadingOverlay } from 'components/LoadingOverlay';
import { CardContainer } from 'features/SignUp/components/CardContainer';
import { Spacer } from 'features/SignUp/components/forms/DocusSignForm/styled';
import { FormTitle } from 'features/SignUp/components/FormTitle';

const tagManagerArgs = {
    gtmId: 'GTM-N6ZDKFX3',
};

TagManager.initialize(tagManagerArgs);

export const Subscribed = () => {
    const queryClient = useQueryClient();
    const [isPageLoading, setIsPageLoading] = useState(true);
    const [message, setMessage] = useState('');
    const [searchParams] = useSearchParams();

    const csId: string = searchParams.get('checkoutSessionId') ?? '';

    const { mutate: subscribeMutate } = useCompleteSubscribeMutation({
        onSuccess: (data) => {
            setMessage(data.message);
        },
        onError: () => {
            toast(
                () => (
                    <Toast title="An error occurred please try again momentarily." />
                ),
                {
                    style: { backgroundColor: 'red' },
                }
            );
        },
    });

    const validityChecks = async () => {
        setIsPageLoading(true);

        if (!csId) {
            window.location.href = '/';
            return false;
        }

        try {
            const userData: IUserProfile = await queryClient.fetchQuery(
                'users/me',
                () => fetchUser()
            );

            if (userData.email) {
                window.location.href = '/';
                return false;
            }
        } catch (err) {
            window.console.error(err);
        }

        subscribeMutate({ csId });

        setIsPageLoading(false);

        return false;
    };

    useEffect(() => {
        void validityChecks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <PublicLayout>
            <CardContainer style={{ marginBottom: 100 }}>
                <LoadingOverlay shown={isPageLoading} />
                <FormTitle
                    title="Catalyze AI Subscription"
                    subtitle={
                        <span style={{ color: 'black' }}>
                            Please wait while we create your account and assign
                            leads.
                            <br />
                            {message}
                        </span>
                    }
                />

                <Spacer />
            </CardContainer>
        </PublicLayout>
    );
};
